export default "__VITE_ASSET__1477942e__"